import * as types from './types';

export const init = (logType) => ({
  type: types.INIT,
  logType,
});

export const fetchDetail = (id) => ({
  type: types.FETCH_DETAIL,
  id,
});

export const setDetail = (detail) => ({
  type: types.SET_DETAIL,
  detail,
});

export const setLogs = (logs) => ({
  type: types.SET_LOGS,
  logs,
});

export const toggleLoading = (status) => ({
  type: types.TOGGLE_LOADING,
  status,
})

export const toggleDetail = (status) => ({
  type: types.TOGGLE_DETAIL,
  status,
})
